import { createAction } from 'redux-actions';
import { PapiSession } from '@wix/da-papi-types';
import { actionKey } from '@wix/da-react-context/pkg/publicSession/constants';
import {
  DeviationViewMode,
  ThreadOrder,
} from '@wix/da-react-context/pkg/publicSession';
import {
  ThemeOptions,
  ThemeSkin,
} from '@wix/da-react-context/pkg/ThemeContext';

export type initializePayload = {
  sessionData: object;
  entities?: object;
};
export const initialize = createAction(
  `${actionKey}/INITIALIZE`,
  (payload: initializePayload) => payload
);
export const updateCommentsOrder = createAction(
  `${actionKey}/UPDATE_COMMENT_ORDER`,
  (order: ThreadOrder) => ({ order })
);
export const updateCommentsOrderDone = createAction(
  `${actionKey}/UPDATE_COMMENT_ORDER_DONE`,
  (order: ThreadOrder) => ({ order })
);

export const toggleTheme = createAction(
  `${actionKey}/TOGGLE_THEME`,
  () => ({})
);
export const toggleThemeDone = createAction(
  `${actionKey}/TOGGLE_THEME_DONE`,
  () => ({})
);
export const setTheme = createAction(
  `${actionKey}/SET_THEME`,
  (theme: ThemeOptions) => ({
    theme,
  })
);
export const setThemeSkin = createAction(
  `${actionKey}SET_THEME_SKIN`,
  (themeSkin: ThemeSkin) => ({
    themeSkin,
  })
);
export const updateAvatar = createAction(
  `${actionKey}/UPDATE_AVATAR`,
  (avatar: any) => ({ avatar })
);

export const updatePointsCount = createAction(
  `${actionKey}/UPDATE_POINTS_COUNT`,
  (pointsCount: number) => ({ pointsCount })
);

export const toggleMature = createAction(
  `${actionKey}/TOGGLE_MATURE`,
  (current: boolean) => ({ current })
);

export const updateContentFilter = createAction(
  `${actionKey}.UPDATE_CONTENT_FILTER`,
  (contentFilter: PapiSession['user']['contentFilter']) => ({ contentFilter })
);

/**
 * Used in instances where the content filter is updated outside the usual usermenu flow
 *
 * This will manually set the publicSession redux to the new content filter without triggering any
 * network requests.
 */
export const syncContentFilter = createAction(
  `${actionKey}.SYNC_CONTENT_FILTER`,
  (contentFilter: PapiSession['user']['contentFilter']) => ({ contentFilter })
);

/**
 * Used in instances where the ai content filter is updated outside the usual usermenu flow
 *
 * This will manually set the publicSession redux to the new ai content filter without triggering any
 * network requests.
 */
export const syncAiContentFilter = createAction(
  `${actionKey}.SYNC_AI_CONTENT_FILTER`,
  (aiContentFilter: PapiSession['user']['aiContentFilter']) => ({
    aiContentFilter,
  })
);

export const resendVerificationEmail = createAction(
  `${actionKey}/RESEND_VERIFICATION_EMAIL`,
  () => ({})
);
export const resendVerificationEmailSuccess = createAction(
  `${actionKey}/RESEND_VERIFICATION_EMAIL/SUCCESS`,
  () => ({})
);
export const resendVerificationEmailFail = createAction(
  `${actionKey}/RESEND_VERIFICATION_EMAIL/FAIL`,
  () => ({})
);
export const updateEmail = createAction(
  `${actionKey}/UPDATE_EMAIL`,
  (email: string) => ({ email })
);
export const updateEmailSuccess = createAction(
  `${actionKey}/UPDATE_EMAIL/SUCCESS`,
  (email: string) => ({ email })
);
export const updateEmailFail = createAction(
  `${actionKey}/UPDATE_EMAIL/FAIL`,
  (email: string) => ({ email })
);

export const setViewMode = createAction(
  `${actionKey}.SET_VIEW_MODE`,
  (viewMode: {
    currentViewMode: DeviationViewMode;
    nextViewMode: DeviationViewMode;
  }) => viewMode
);

export const setIsMobile = createAction(
  `${actionKey}/SET_MOBILE`,
  (isMobile: boolean) => ({
    isMobile,
  })
);

export const setFeedbackCount = createAction(
  `${actionKey}/SET_FEEDBACK_COUNT`,
  (count: number) => count
);

// Chat Settings
export const setChatSettingOnline = createAction(
  `${actionKey}.CHAT_SETTING_ONLINE`,
  value => ({ value })
);
export const setChatSettingMuted = createAction(
  `${actionKey}.CHAT_SETTING_MUTED`,
  value => ({ value })
);
export const setChatSettingSoundsMuted = createAction(
  `${actionKey}.CHAT_SETTING_SOUNDS_MUTED`,
  value => ({ value })
);
